// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2gqPj","footer":"Form_footer__FDMHD"};